import React from 'react';
import {
    DateField,
    Datagrid,
    ShowButton,
    TextField,
    FunctionField,
    Link,
} from 'react-admin';
import { formatMoney } from '../../core/utils/money';
import ChargeUserField from './ChargeUserField';
import ChargePartnerField from './ChargePartnerField';
import ChargeCountryField from './ChargeCountryField';
import ChargeInvoiceField from './ChargeInvoiceField';
import ChargeOrderField from './ChargeOrderField';

const sanitizeRestProps: (any) => any = ({
    hasEdit,
    hasList,
    hasShow,
    ...rest
}) => rest;

const ChargeGrid = props => (
    <Datagrid {...sanitizeRestProps(props)}>
        <TextField source="serial" sortable={false} />
        <TextField source="id" />
        <ChargePartnerField link="show" label="Partner" />
        <ChargeInvoiceField link="show" label="Invoice" />
        <TextField source="type" />
        <DateField
            locales="en-IN"
            source="createdAt"
            showTime
            label="Created"
        />
        <TextField source="year" />
        <TextField source="month" />
        <TextField source="startDate" label="Start" />
        <TextField source="endDate" label="End" />
        <ChargeOrderField link="show" label="Order" />
        <FunctionField
            label="Request"
            render={record =>
                record.requestId ? (
                    <Link to={`/requests/${record.requestId}/show`}>
                        {record.requestId}
                    </Link>
                ) : (
                    ' '
                )
            }
        />
        <ChargeUserField link="show" label="Customer" />
        {/* <ChargeCountryField link="show" label="Country" /> */}
        {/*<MoneyField source="amount" showCurrency />*/}
        <FunctionField
            label="Amount"
            render={record => {
                return record.type === 'credit' ? (
                    <>
                        <small style={{ display: 'block' }}>
                            {record.currency}
                        </small>
                        -{formatMoney(record.amount, record.currency)}
                    </>
                ) : (
                    <>
                        <small style={{ display: 'block' }}>
                            {record.currency}
                        </small>
                        {formatMoney(record.amount, record.currency)}
                    </>
                );
            }}
        />
        <TextField source="description" />
        <FunctionField
            label="Source"
            render={record => record?.metadata?.source || '-'}
        />
        {props.hasShow && <ShowButton label="" style={{ padding: 0 }} />}
    </Datagrid>
);

export default ChargeGrid;
